/*
 * @todo remove this file.
 * This file should be remove as soon as hybris seo content will be migrated to prismic
 * It contains custom styles and selectors from shop reboot.
 */
var HYBRIS_CONTAINER_SELECTOR = '.hybris-seo';
export var HYBRIS_SELECTORS = {
    liCheck: HYBRIS_CONTAINER_SELECTOR + " ul.cms-list-checked li",
    liCross: HYBRIS_CONTAINER_SELECTOR + " ul.list-cons li",
    liCheckBefore: HYBRIS_CONTAINER_SELECTOR + " ul.cms-list-checked li::before",
    liCrossBefore: HYBRIS_CONTAINER_SELECTOR + " ul.list-cons li::before",
    box: HYBRIS_CONTAINER_SELECTOR + " .box",
    nav: HYBRIS_CONTAINER_SELECTOR + " .list-jump",
    img: HYBRIS_CONTAINER_SELECTOR + " .img-center",
};
export var HYBRIS_CUSTOM_STYLES = "\n  " + HYBRIS_CONTAINER_SELECTOR + " {\n    .list-jump {\n      padding-left: 32px;\n    }\n\n    .cms-list-bullet li:before {\n      color: #f45334;\n    }\n\n    .seo-scrollable-container {\n      overflow-x: auto;\n    }\n\n    .box {\n      margin: 16px 0;\n    }\n\n    .cms-first {\n      text-align: center;\n    }\n\n    table {\n      border-spacing: 0;\n      border-collapse: collapse;\n    }\n\n    td, th {\n      vertical-align: middle;\n      border: 1px solid #ddd;\n      padding: 10px;\n    }\n\n    img {\n      max-width: 100%;\n    }\n  }\n";
